import React from "react";
import StarIcon from "assets/images/icons/star.svg";
import UnFilledStarIcon from "assets/images/icons/unFilledStar.svg";
import { Rating } from "primereact/rating";

const CustomStar = ({ rating, readOnly = true }) => {
  return (
    <Rating
      value={rating}
      readOnly={readOnly}
      stars={5}
      onIcon={<img src={StarIcon} alt="filled" width={20} />}
      offIcon={<img src={UnFilledStarIcon} alt="empty" width={20} />}
      cancel={false}
      className="custom_rating_star"
    />
  );
};

export default CustomStar;
